var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"title":"دریافت فایل اکسل برای بارگذاری"}},[_c('b-button',{staticClass:"btn btn-success",on:{"click":_vm.download}},[_vm._v("دریافت فایل")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }